import { IApplicationState } from '../../types/redux';

export function hasMvk(state: IApplicationState) {
  return state.mvk.hasMVK;
}
